import React from "react";
import ReportWidgetType from "./ReportWidgetType";
import Widget from "../../widget/Widget";
import IReportWidgetProps from "../../../../../model/interface/report/IReportWidgetProps";
import ViewWidget from "./ViewWidget";
import IReportWidgetView from "../../../../../model/interface/report/IReportWidgetView";
import EmployeeLookupWidget from "./EmployeeLookupWidget";
import NotificationsWidget from "./NotificationsWidget";
import ResourceFinderByCodeWidget from "./ResourceFinderByCodeWidget";
import VacationWidget from "./VacationWidget";
import MenuWidget from "./MenuWidget";
import WorkloadReportWidget from "./WorkloadReportWidget";
import WorkloadAttendanceWidget from "./WorkloadAttendanceWidget";

class ReportWidget extends React.Component<IReportWidgetProps> {

    static getWidget(type: string, props: IReportWidgetProps) {
        switch (type) {
            case(ReportWidgetType.VIEW):
                return <ViewWidget {...props as IReportWidgetProps<IReportWidgetView>}/>
            case(ReportWidgetType.EMPLOYEE_LOOKUP):
                return <EmployeeLookupWidget {...props}/>
            case(ReportWidgetType.NOTIFICATIONS):
                return <NotificationsWidget {...props}/>
            case(ReportWidgetType.RESOURCE_FINDER_BY_CODE):
                return <ResourceFinderByCodeWidget {...props}/>
            case(ReportWidgetType.VACATION):
                return <VacationWidget {...props}/>
            case(ReportWidgetType.MENU):
                return <MenuWidget {...props}/>
            case(ReportWidgetType.WORKLOAD_REPORT):
                return <WorkloadReportWidget {...props}/>
            case(ReportWidgetType.WORKLOAD_ATTENDANCE):
                return <WorkloadAttendanceWidget {...props}/>
            default:
                return Widget.getWidget(type, props)
        }
    }

    render(): JSX.Element {
        return Widget.renderWidget({...this.props, customWidget: ReportWidget}, ReportWidget.getWidget)
    }
}

export default ReportWidget